/**
 * @class Validator
 * @description Class in charge of validating Health Card Numbers depending on region. Scalable to different regions.
 * Must use same country and region codes as in database.
 */
class PhoneNumberValidator {

    /**
     * @private
     * @type {Object}
     * @memberof PhoneNumberValidator
     * @description 
     *      - textMask used by the application MaskedInput component. 
     *      - regExp: Regular expressio 
     */
    private readonly countryRegionData: object = {
        CA: {
            placeHolder: "____ ____ ____",
            regExp: /^(\d{10})$/,
            textMask: "+\\1 (111) 111-1111",
        },
        MX: {
            placeHolder: "____ ____ ____",
            regExp: /^(\d{10})$/,
            textMask: "+\\5\\2 (11) 1111-1111",
        },
        CO: {
            placeHolder: "____ ____ ____",
            regExp: /^(\d{10})$/,
            textMask: "+\\5\\7 (111) 111-1111",
        },
        US: {
            placeHolder: "____ ____ ____",
            regExp: /^(\d{10})$/,
            textMask: "+\\1 (111) 111-1111",
        },
        Other: {
            placeHolder: "____ ____ ____",
            regExp: /^(d{10})$/,
            textMask: "+\\1 (111) 111-1111",
        }
    }
    public validatePhoneNumber(phoneNumber: string, country: string): boolean {
        if (phoneNumber.length === 0) {
            return false;
        }
        try {
            return this.countryRegionData[country].regExp.test(phoneNumber);
        }
        catch {
            return false;
        }
    }
    public getPhoneTextMaskByCountry(country: string): string {
        return this.countryRegionData[country].textMask;
    }
    public validatePhoneNumberExtension(extension: string): boolean {
        return /^\d+$/.test(extension) || extension.length === 0;
    }
}
export default new PhoneNumberValidator();

export const formatInputAccordingToMask = (input:string, mask: string) => {
    if (mask === null || mask === "") {
        return input;
    }

    let returnString = "";
    if (input) {
        for (let i = 0; i < mask.length; i++) {
            if (mask[i] === '\\') {
                i++;
                returnString = returnString + mask[i];
            } else if (mask[i] !== 'A' && mask[i] !== "1") {
                returnString = returnString + mask[i];
            } else {
                returnString = returnString + input[0];
                if (input.length >= 2) {
                    input = input.substring(1);
                } else {
                    input = "";
                    break;
                }
            }
        }
    }
    return returnString;
}


// WEBPACK FOOTER //
// ./src/services/Validator/PhoneNumber/PhoneNumberValidator.ts